module.exports = __webpack_public_path__ + "img/leonel_stete.896678ec.png";